<template>
    <div>
        <div class="page">
            <div class="body" v-if="bodyShow">
                <div class="my-task" style="border:0">
                    <div class="my-task-center">
                        <div class="task-user-logo">
                            <img :src="msgWork.photo" :onerror="defaultImg" />
                        </div>
                        <div class="task-user-content">
                            <div class="task-user-info">
                                <div class="task-user-name">
                                    {{msgWork.user_name}}
                                </div>
                            </div>

                            <div class="task-user-answer">
                                <div v-text="msgWork.content" class="task-user-txt"></div>
                                <div class="task-user-img" v-if="msgWork.res_type == 1">
                                    <div class="my-gallery">
                                        <div @click="previewImg" v-for="(item,index) in msgWork.images" :data-src="item">
                                            <img :src="item" v-if="msgWork.images.length==1" style="height:48vw" />
                                            <img :src="item" v-if="msgWork.images.length>1" />
                                        </div>
                                    </div>
                                </div>
                                <!-- 音频 -->
                                <div>
                                    <div class="task-audio" v-if="msgWork.res_type == 2">
                                        <div class="task-audio-btn" @click="chooseAudioMsgWorkPlay" :data-src="msgWork.res_datas[0]">
                                            <span :class="'iconfont '+(msgWork.isPlayingMusic?'iconbofang1':'iconbofang11')"></span>
                                        </div>
                                        <div class="task-audio-slider">
                                            <van-slider class='slider'
                                                        v-model="msgWork.int_time"
                                                        :max="msgWork.int_max_time"
                                                        button-size="12px"
                                                        active-color="#327CE9"
                                                        inactive-color="#cccccc"
                                                        disabled />
                                        </div>
                                        <div class="task-audio-time" v-if="msgWork.int_max_time>0">
                                            {{msgWork.max_time || '00:00'}}
                                        </div>
                                    </div>
                                </div>

                                <div class="task-user-btn">
                                    <div class="task-user-time">
                                        {{msgWork.create_time_cn}}
                                    </div>
                                    <div class="task-message-btn" @click="handleProxy" :data-user_name="msgWork.user_name" :data-index="msgWork.index">
                                        <span class="iconfont iconmessage"></span>
                                    </div>
                                    <div class="task-info-love" @click="favorSave" :data-index="msgWork.index">
                                        <span class="favor-cnt">{{msgWork.favors.length}}</span><span class="iconfont iconaixin" :style="'color:'+(msgWork.is_favor?'#f30':'#8a8a8a')"></span>
                                    </div>
                                </div>
                                <div class="ca-item" v-if="msgWork.favors && msgWork.favors.length>0">
                                    <span class="iconfont iconaixin" style="color:#f30;font-size: 12px"></span>
                                    <span v-for="(item_fav,index_fav) in msgWork.favors" :key="item_fav.user_id" style="color: #71a3ae;font-size: 12px">
                                        {{index_fav==0?item_fav.user_name:'，'+item_fav.user_name}}
                                    </span>
                                    <span v-if="msgWork.favors.length>8">等{{msgWork.favor_cnt}}人赞过</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="text-align:center">
                    <div class="msg-h1">全部回复</div>
                </div>

                <van-list
                        v-model="loading"
                        :finished="is_reply_show"
                        finished-text="暂无更多记录"
                        :immediate-check="false"
                        @load="getReplyList"
                        offset="10"
                >
                <div class="task-dynamic-center" v-for="(item,index) in reply_list">
                    <div class="task-user-logo">
                        <img :src="item.user_photo" :data-index="index"
                               :onerror="defaultImg" />
                    </div>
                    <div class="task-user-content">
                        <div class="task-user-info">
                            <div class="task-user-name">
                                {{item.user_name}}
                            </div>
                        </div>
                        <div class="task-user-answer">
                            <div class="task-user-txt">{{item.reply_content}}
                                <span v-if="item.to_user_id>0">
                                    <span style="margin:0 5px;color:#ccc">//@{{item.to_user_name}}:</span>
                                    {{item.to_reply_content}}
                                </span>
                            </div>
                            <div class="task-user-btn">
                                <div class="task-user-time">
                                    {{item.create_time_cn}}
                                </div>
                                <div class="task-message-btn" @click="handleProxy" :data-user_name="item.user_name"
                                      :data-work_reply_id="item.work_reply_id"
                                      :data-index="msgWork.index">
                                    <span class="iconfont iconmessage"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                </van-list>
            </div>
        </div>

        <div class="send-chat" :style="'bottom:'+chatBottom+'px'" v-if="isChat">
            <input
                    :placeholder="MsgPlaceholder"
                    @focus="getChatBottom"
                    @blur="setChatBottom"
                    @keyup.enter="sendMsg"
                    @input="setMsgDetail"
                    ref="getFocus"
                    type="text"
            />
            <div class="btn-send" @click="sendMsg">发送</div>
        </div>
    </div>
</template>

<script>
    var innerAudioContext=null;
    var audioInterval=null;
    import {Image as VanImage,List,ImagePreview} from 'vant';
    export default {
        name: "comment_detail",
        components:{
            [VanImage.name]:VanImage,
            [List.name]:List
        },
        data(){
            return {
                defaultImg:'this.src="https://o-yzx.bysjy.com.cn/notice/photo_default.png"',

                bodyShow:false,
                work_answer_id:'',
                msgWork:{},
                loading:false,

                chatBottom:0,//留言框bottom大小
                isChat:false,//显示留言输入框
                MsgValue:'',//留言类容
                MsgIndex:0,//留言位置
                to_work_reply_id:'',//回复人ID
                MsgPlaceholder:'回复',//留言默认显示提示

                reply_page:1,//回复列表页数
                reply_pageSize:10,//回复列表条数
                reply_list:[],//回复列表
                reply_total:0,//回复列表总数量
                is_reply_show:false,//回复列表无数据时是否显示提示
            }
        },
        mounted() {
            this.util.hideOptionMenu();
            this.work_answer_id = this.util.getQueryStr('work_answer_id') || '';

            this.getDetail()
        },

        beforeCreate () {
            document.querySelector('body').setAttribute('style', 'background-color:#fff')
        },
        //离开页面事件
        beforeRouteLeave(to, form, next) {
            document.querySelector('body').setAttribute('style', 'background-color:#f8f8f8')
            next();
        },
        methods:{
            getDetail(){
                var _self=this;

                this.util.server.mini_work.answer_detail({
                    data:{
                        work_answer_id:this.work_answer_id
                    },
                    callback:(res=>{
                        res.data.is_favor = 0;
                        for (var i =0;i<res.data.favors.length;i++){
                            if(res.data.favors[i].user_id == res.data.user_id){
                                res.data.is_favor =1;
                            }
                        }
                        _self.msgWork = res.data;


                        _self.getReplyList(1);
                    })
                })
            },
            //点赞
            favorSave:function(e){
                var work_answer_id = this.work_answer_id;

                this.util.server.mini_work.favor({
                    data:{
                        work_answer_id:work_answer_id,
                    },
                    callback:(res=>{
                        if(res.code == -1){
                            return
                        }
                        var favors_list =[];
                        if(res.data.is_favor){
                            var param = {
                                user_id:this.util.getUserId.get(),
                                user_name:res.data.user_name
                            };
                            favors_list = this.msgWork['favors'];
                            favors_list.push(param);
                        }else{
                            for (var i =0;i<this.msgWork.favors.length;i++){
                                var item = this.msgWork.favors[i];
                                if(item.user_id == this.util.getUserId.get()){
                                    continue;
                                }
                                favors_list.push(item)
                            }
                        }
                        this.msgWork.is_favor=res.data.is_favor;
                        this.msgWork.favors = favors_list;
                    })
                })
            },
            /********************************留言start*******************************/
            //点击留言
            handleProxy:function(e){
                this.isChat=true;
                this.work_answer_id = this.work_answer_id;
                this.MsgIndex = e.currentTarget.dataset.index;
                this.MsgPlaceholder = this.MsgPlaceholder + ' '+e.currentTarget.dataset.user_name;
                this.to_work_reply_id = e.currentTarget.dataset.work_reply_id || ''

                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.$refs.getFocus.focus();// 等价  document.getElementById("inputValId").focus();
                }, 100);
            },
            //获取输入法高度
            getChatBottom:function(e){
                this.chatBottom = e.target.height || 0;
            },
            //初始化留言bottom
            setChatBottom:function(){
                this.chatBottom = 0;
                if(this.MsgValue  == ''){
                    this.isChat = false;
                    this.to_work_reply_id = '';
                    this.MsgValue = '';
                    this.MsgIndex = 0;
                    this.MsgPlaceholder = '回复';
                }
            },
            //发送留言
            sendMsg:function(e){
                var val = this.MsgValue.replace(/\s+/g, '');
                var _self=this;
                if(val == ''){
                    this.isChat = false;
                    this.to_work_reply_id = '';
                    this.MsgIndex = 0;
                    this.MsgPlaceholder = '回复';
                    return false;
                }

                this.util.server.mini_work.reply({
                    data:{
                        work_answer_id:this.work_answer_id,
                        to_work_reply_id:this.to_work_reply_id,
                        reply_content:val
                    },
                    callback:(res=>{

                        if(res.code == -1){
                            this.isChat = false;
                            this.to_work_reply_id = '';
                            this.MsgIndex = 0;
                            this.MsgValue='';
                            this.MsgPlaceholder = '回复';
                            return false;
                        }

                        var replyArr = this.reply_list;

                        var arr=[];
                        arr.push(res.data);
                        arr = arr.concat(replyArr);

                        this.reply_list=arr;

                        this.isChat = false;
                        this.to_work_reply_id = '';
                        this.MsgIndex = 0;
                        this.MsgValue='';
                        this.MsgPlaceholder = '回复';
                    })
                })
            },
            //回显输入内容
            setMsgDetail:function(e){
                this.MsgValue = e.target.value;
            },
            /********************************留言end*******************************/
            lowerThresholdReply:function(){
                var list=this.reply_list;
                if(list.length >= this.reply_total){
                    this.is_reply_show=true;
                    return false;
                }
                this.getReplyList();
            },
            getReplyList:function(page){

                var _self=this;
                if(!page){
                    var pageNo = this.reply_page;
                    pageNo +=1;

                    this.reply_page = pageNo;

                }else{

                    this.reply_page = page;

                }

                this.util.server.mini_work.reply_list({
                    data:{
                        work_answer_id:this.work_answer_id,
                        page:this.reply_page,
                        pagesize:this.reply_pageSize
                    },
                    callback: (res => {
                        this.bodyShow=true;
                        this.loading=false;
                        const { code, data, msg } = res;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.reply_total = data.total
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.reply_list = data.items
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.reply_list = this.reply_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.is_reply_show=false;

                                if(this.reply_total*1 == this.reply_list.length){
                                    this.is_reply_show=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.reply_list=[];
                                    this.is_reply_show=true;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            //作业图片查看
            previewImg:function(e){
                var img = e.currentTarget.dataset.src;
                var arr=this.msgWork.images;

                var strat=0;
                for (var i =0;i<arr.length;i++){
                    if(arr[i] == img){
                        strat = i;
                        break;
                    }
                }

                ImagePreview({
                    images:arr,
                    startPosition:strat,
                    closeable: true
                });
            },

            chooseAudioMsgWorkPlay:function(e){
                var src = e.currentTarget.dataset.src;
                var _self=this;
                if(innerAudioContext && !innerAudioContext.pause()){
                    innerAudioContext.pause();
                }
                clearInterval(audioInterval);
                var isPlayingMusic = this.msgWork.isPlayingMusic || false;

                if(isPlayingMusic){
                    this.msgWork.isPlayingMusic = false;
                    this.$forceUpdate();
                    innerAudioContext.pause();
                }else{
                    this.msgWork.isPlayingMusic = true;
                    this.$forceUpdate();
                    innerAudioContext = new Audio();
                    innerAudioContext.src=src;
                    if(!this.msgWork.int_max_time){
                        innerAudioContext.addEventListener('loadedmetadata', function() {
                            _self.msgWork.max_time=_self.util.getTime(innerAudioContext.duration);
                            _self.msgWork.int_max_time=innerAudioContext.duration;
                            _self.msgWork.int_time=innerAudioContext.currentTime;
                            _self.$forceUpdate();
                        })
                    }
                    innerAudioContext.play();
                    innerAudioContext.currentTime=0;
                    this.setAudioWorkInterval();
                }
            },

            //设置定时检测
            setAudioWorkInterval(){
                audioInterval = setInterval(()=>{

                    this.msgWork.int_time = innerAudioContext.currentTime;
                    this.$forceUpdate();
                    if(innerAudioContext.ended){
                        //播放结束后重置数据
                        clearInterval(audioInterval);

                        this.msgWork.isPlayingMusic=false;
                        this.$forceUpdate();
                        innerAudioContext.currentTime=0;
                    }
                    if(innerAudioContext.paused){
                        this.msgWork.isPlayingMusic=false
                        this.$forceUpdate();
                    }else{
                        this.msgWork.isPlayingMusic=true
                        this.$forceUpdate();
                    }
                },500)
            },
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .my-task{
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        margin: 0 0 -1px -1px;

        padding: 10px;
        box-sizing: border-box;
    }
    .my-task .my-task-title{
        padding-bottom: 2px;
        border-bottom: 3px solid #666;
        width: 90px;
        font-weight: bold;
    }
    .my-task .my-task-center{
        margin-bottom: 10px;
        position: relative;
    }
    .task-user-logo{
        width: 40px;
        font-size: 0;
        position: absolute;
        top: 0;
    }
    .task-user-logo img{
        width: 40px;
        height: 40px;
        border-radius: 20px;
    }
    .task-user-content{
        display: inline-block;
        width: 100%;
        padding-left: 50px;
        box-sizing: border-box;
    }
    .task-user-info{
        position: relative;
        height: 40px;
        line-height: 40px;
    }
    .task-user-info .task-user-name{
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .task-user-info .task-edit{
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        text-align: center;
        color: #4395ff;
    }
    .task-user-answer .task-user-img{
        overflow: hidden;
        margin-top: 15px;
        font-size: 0;
    }
    /*.task-user-answer .task-user-img image{*/
    /*width: 40px;*/
    /*height: 40px;*/
    /*border-radius: 10px;*/
    /*margin-right: 10px;*/
    /*margin-bottom: 10px;*/
    /*}*/
    .task-user-answer .task-user-txt{
        margin: 10px 0;
        white-space: pre-wrap;
    }
    .task-user-btn{
        display: flex;
    }
    .task-user-btn .task-user-time{
        font-size: 12px;
        color: #aaa;
        flex: 1;
    }
    .task-user-btn .task-message-btn{
        width: 40px;
        text-align: center;
    }
    .task-user-btn .task-info-love{
        text-align: right;
        min-width: 40px;
    }
    .task-user-btn .iconfont{
        color: #8a8a8a;
        font-size: 20px;
    }
    .task-dynamic{
        padding: 10px;
    }
    .task-dynamic-title{
        padding-bottom: 2px;
        border-bottom: 3px solid #666;
        width: 90px;
        font-weight: bold;
    }
    .task-dynamic-center{
        margin: 10px 0;
        position: relative;
        padding: 10px;
        box-sizing: border-box;
    }
    .comment-area{
        background: #f5f5f5;
        border-radius: 4px;
        margin-top: 5px;
        padding: 5px 0;
        margin-bottom: 5px;
        position: relative;
    }
    .comment-area::before{
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-color: transparent transparent #f5f5f5 transparent;
        border-top-width: 0;
        top: -8px;
        left: 20px;
    }
    .comment-area .ca-item{
        padding: 0 5px;
        position: relative;
    }
    .task-dynamic .task-dynamic-center:last-child{
        margin-bottom: 41px;
    }
    .pub-orange-text{
        color: #ff9234;
    }
    .ca-whole-item{
        font-size: 12px;
        padding: 0 5px;
        color: #4395ff;
        padding-top: 5px;
    }
    .ca-whole-item .iconfont{
        vertical-align: middle;
    }
    .edit-task{
        position: fixed;
        bottom: 0;
        background-color: #fff;
        width: 100%;
        border-top: 1px solid #ccc;
        text-align: center;
        padding: 10px 0;
    }
    .pub-user-text{
        color: #71a3ae;
    }
    .send-chat{
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 5px;
        background-color: #fff;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        z-index: 99999;
    }
    .send-chat input{
        padding: 5px;
        background-color: #f3f3f3;
        padding-right: 47px;
    }
    .chat-content .chat-details{
        width: 100%;
        height: 100%;
        padding: 10px;
        /*overflow-y: auto;*/
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .send-chat .btn-send{
        position: absolute;
        top: 0;
        right: 0;
        height: 1.4rem;
        margin-right: 5px;
        margin-top: 5px;
        padding: 5px;
        line-height: 1.4rem;
        letter-spacing: 2px;
        border-left: 1px solid #ccc;
    }
    .mag-list{
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        transition:all .2s ease-in-out;
        opacity:0;
        visibility:hidden
    }
    .i-as-mask-show{
        opacity:1;
        visibility:visible
    }
    .mag-list .msg-content{
        height: 90%;
        width: 100%;
        position: absolute;
        background-color: #ffffff;
        transform:translate3d(0,100%,0);
        transform-origin:center;
        transition:all .2s ease-in-out;
        top: 10%;
        visibility:hidden;
        z-index: 10;
        border-radius: 20px 20px 0 0;
        overflow: hidden;
        padding: 0 15px;
        box-sizing: border-box;
    }
    .mag-list .i-as-show{
        transform:translate3d(0,0,0);
        visibility:visible
    }
    .msg-header .msg-header-txt{
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
        position: relative;
    }
    .msg-header-txt .icon{
        position: absolute;
        right: 0;
        top: 10px;
    }
    .msg-h1{
        font-weight: bold;
        font-size: 16px;
        text-align: center;
        position: relative;
        display: inline-block;
    }
    .msg-h1:after,.msg-h1:before{
        content: '';
        position: absolute;
        height: 2px;
        width: 30px;
        background-color: #ccc;
        top: 50%;
        border-radius: 2px;
    }
    .msg-h1:before{
        left: -40px;
    }
    .msg-h1:after{
        right: -40px;
    }
    .no-list{
        text-align: center;
        width: 100%;
        margin: 10px 0;
        color: #999;
        font-size: 12px;
    }
    .favor-cnt{
        font-size: 12px;
        vertical-align: middle;
    }
    .task-info-love .iconaixin{
        vertical-align: middle;
    }
    .send-chat{
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 5px;
        background-color: #fff;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        z-index: 99999;
    }
    .send-chat input{
        padding: 5px;
        background-color: #f3f3f3;
        padding-right: 47px;
    }
    .chat-content .chat-details{
        width: 100%;
        height: 100%;
        padding: 10px;
        /*overflow-y: auto;*/
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .send-chat .btn-send{
        position: absolute;
        top: 0;
        right: 0;
        height: 1.4rem;
        margin-right: 5px;
        margin-top: 5px;
        padding: 5px;
        line-height: 1.4rem;
        letter-spacing: 2px;
        border-left: 1px solid #ccc;
    }
    .page{
        height: 100%;
        background-color: #fff;
        display: flex;
        flex: 1;
        flex-direction: column;
    }
    .my-gallery{
        width: 100%;
        float: left;
    }
    .my-gallery div{
        display: block;
        float: left;
        margin: 0 2px 2px 0;
    }
    .my-gallery div img{
        width: 24vw;
        height: 24vw;
        display: block;
    }

    .send-chat input{
        padding: 5px;
        background-color: #f3f3f3;
        padding-right: 47px;
        border: 0;
        width: 100%;
        height: 32.39px;
        box-sizing: border-box;
    }
</style>
